import React from 'react'
import styled from 'styled-components'
import Link from 'components/link'
import { assetPrefix } from 'config/env_config'
import { MEDIA, PAGE_URL } from 'utils'
const PETANJO_BASE_SITE = process.env.PETANJO_BASE_SITE || ''

// Media query
const { MOBILE } = MEDIA

const FooterContainer = styled.footer`
  z-index: 3;
  margin-top: auto;
  background-color: var(--the-gray);
  padding: 32px 0;
  color: var(--the-black);

  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;

  @media screen and ${MOBILE} {
    padding: 20px;
    flex-direction: column;
  }
`

const Disclaimer = styled.p`
  font-weight: 600;
  font-size: 11.5px;
  font-family: var(--secondary-font);
  max-width: 784px;

  @media screen and ${MOBILE} {
    order: 3;
  }
`

const Title = styled.h4`
  font-size: 17px;
  font-weight: 600;
  font-family: var(--primary-font);
  margin-bottom: 12px;
`

const LinksList = styled.div`
  position: relative;
  padding-left: 12px;

  @media screen and ${MOBILE} {
    padding: 0;
    order: 1;
    align-self: flex-start;
    margin-bottom: 45px;
  }

  :after {
    content: '';
    height: 96px;
    width: 1px;
    background-color: var(--the-black);

    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);

    @media screen and ${MOBILE} {
      display: none;
    }
  }

  ul {
    list-style: none;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    gap: 12px;

    li {
      a {
        text-decoration: none;
        color: var(--the-black);
        font-size: 12px;
        font-weight: 600;
        font-family: var(--primary-font);
        display: block;
      }
    }
  }
`

export const DisclaimerText = styled.p`
  display: inline-block;
  font-size: 11.5px;
  line-height:16px;
  font-weight: 600;
  font-family: var(--primary-font);
  margin: 0.5rem 0;
`

const createLinkItem = (link, label, isInternal) => isInternal
  ? (
    <li>
      <Link href={link}>
        <a>{label}</a>
      </Link>
    </li>
  )
  : (
    <li>
      <a target='_blank' href={link} rel='noopener noreferrer'>{label}</a>
    </li>
  )

const AppLogoLink = styled.a`
  @media screen and ${MOBILE} {
    order: 2;
  }
`

const AppLogo = ({ alt, href, src }) => (
  <AppLogoLink href={href}>
    <img src={src} alt={alt} />
  </AppLogoLink>
)

const Footer = ({ isReactNative }) => {
  return (
    <FooterContainer id='footer' data-test='container-footer'>
      <AppLogo
        href={`${assetPrefix}${PAGE_URL.SCHEDULING_INDEX}`}
        src={`${assetPrefix}/static/images/logo-petanjo.svg`} alt='Logo Pet Anjo - Spet'
      />
      <Disclaimer>A Pet Anjo realiza, através de uma plataforma proprietária de agendamento online, o papel de intermediação na contratação de serviços prestados entre usuários e empresas especializadas em serviços para Pet, nas áreas de Banho & Tosa, Clínica Veterinária, Petsitter, Dogwalker, Creche e Hotelaria. Através desta plataforma, usuários podem contratar os serviços oferecidos por estas empresas parceiras que atuam com responsabilidade própria. Empresas parceiras e usuários reconhecem expressamente que a Pet Anjo não é parte de quaisquer acordos celebrados na relação de contratação dos serviços.</Disclaimer>

      {!isReactNative && (
        <LinksList>
          <Title>Políticas e Regras</Title>
          <ul>
            {createLinkItem(`${PETANJO_BASE_SITE}/politica-de-privacidade`, 'Política de privacidade')}
            {createLinkItem(PAGE_URL.SERVICE_TERMS, 'Política de uso', true)}
            {createLinkItem('https://suporte.petanjo.com/hc/pt-br', 'Central de Ajuda e Regulamentos', true)}
          </ul>
        </LinksList>
      )}
    </FooterContainer>
  )
}

export default Footer
